var map = {
	"./main/auth/auth.module": [
		"./src/app/main/auth/auth.module.ts",
		"main-auth-auth-module"
	],
	"./main/badges/badges.module": [
		"./src/app/main/badges/badges.module.ts",
		"main-badges-badges-module"
	],
	"./main/connect-organization/connect-organization.module": [
		"./src/app/main/connect-organization/connect-organization.module.ts",
		"common",
		"main-connect-organization-connect-organization-module"
	],
	"./main/elements/elements.module": [
		"./src/app/main/elements/elements.module.ts",
		"default~main-elements-elements-module~main-routes-routes-module",
		"main-elements-elements-module"
	],
	"./main/first-login/first-login.module": [
		"./src/app/main/first-login/first-login.module.ts",
		"main-first-login-first-login-module"
	],
	"./main/help/help.module": [
		"./src/app/main/help/help.module.ts",
		"main-help-help-module"
	],
	"./main/home/home.module": [
		"./src/app/main/home/home.module.ts",
		"main-home-home-module"
	],
	"./main/routes/routes.module": [
		"./src/app/main/routes/routes.module.ts",
		"default~main-elements-elements-module~main-routes-routes-module",
		"default~main-routes-routes-module~main-settings-settings-module",
		"main-routes-routes-module"
	],
	"./main/send-confirmation/send-confirmation.module": [
		"./src/app/main/send-confirmation/send-confirmation.module.ts",
		"main-send-confirmation-send-confirmation-module"
	],
	"./main/settings/settings.module": [
		"./src/app/main/settings/settings.module.ts",
		"default~main-routes-routes-module~main-settings-settings-module",
		"main-settings-settings-module"
	],
	"./main/welcome/welcome.module": [
		"./src/app/main/welcome/welcome.module.ts",
		"main-welcome-welcome-module"
	],
	"app/main/auth/collaborator-register/collaborator-register.module": [
		"./src/app/main/auth/collaborator-register/collaborator-register.module.ts",
		"common",
		"app-main-auth-collaborator-register-collaborator-register-module"
	],
	"app/main/auth/email-confirmation/email-confirmation.module": [
		"./src/app/main/auth/email-confirmation/email-confirmation.module.ts",
		"app-main-auth-email-confirmation-email-confirmation-module"
	],
	"app/main/auth/login/login.module": [
		"./src/app/main/auth/login/login.module.ts",
		"common",
		"app-main-auth-login-login-module"
	],
	"app/main/auth/register/register.module": [
		"./src/app/main/auth/register/register.module.ts",
		"app-main-auth-register-register-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;